import { BaseComponent } from "../base.component";
import {
  Component,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { ModalDirective } from "ng-uikit-pro-standard";
import { FormGroup, FormControl } from "@angular/forms";
import { JobService } from "../../service/job.service";
import { ChappsImageCropperComponent } from "@npm.chapps.com/chapps.common.angular.library";
import { MultimediumType } from "../../enums/enums";
import { Multimedium } from "../../model/multimedium";
import { UploadingImage } from '@npm.chapps.com/chapps.common.angular.library/lib/components/others/image-cropper/model/uploading-image';
import { forkJoin } from 'rxjs';
import { $ } from "protractor";

@Component({
  selector: "app-execute-modal",
  templateUrl: "./execute-modal.component.html",
  styleUrls: ["./execute-modal.component.scss"]
})
export class ExecuteModalComponent extends BaseComponent {
  public formGroup: FormGroup;
  public showUnsupportedFileExtensionMessage: boolean;
  public showFileUploadErrorMessage: boolean;
  public multimedia: Multimedium[];
  public multimediaFiles: File[];
  private supportedFileTypes: string[];
  public submitting: boolean;
  public isMediaAdding: boolean = false;

  @ViewChild(ChappsImageCropperComponent)
  chappsImageCropperComponent: ChappsImageCropperComponent;
  @ViewChild("modal") modal: ModalDirective;
  @ViewChild('file') file;
  @ViewChild('image') image;

  @Input() id: string;
  @Input() ids?: string[] = [];
  @Input() type: string;
  @Input() readonly: boolean;
  @Output() success: EventEmitter<null> = new EventEmitter<null>();
  public completed: boolean;

  public get feedbackFC() {
    return this.formGroup.get("feedback");
  }

  constructor(
    private jobService: JobService,
  ) {
    super();
  }

  ngOnInit() {
    this.supportedFileTypes = ['image/jpeg', 'image/png'];
    this.multimedia = [];
    this.multimediaFiles = [];
    this.initForm();
    this.resetForm();
  }

  private initForm() {
    this.formGroup = new FormGroup({
      feedback: new FormControl(null)
    });
  }

  private resetForm() {
    this.formGroup.setValue({
      feedback: null
    });
  }

  private get allJobs(): string[] {
    if(this.ids.length === 0){
      return [this.id];
    }else{
      return [this.id, ...this.ids].filter(id => !!id);
    }
  }

  public get hasMultipleJobs(): boolean {
    return this.ids?.length > 1;
  }

  public execute() {
    this.submitting = true;
    forkJoin(this.allJobs.map(job => this.jobService.executeJob(
        job,
        this.formGroup.controls.feedback.value,
        this.multimediaFiles
      ))
    ).subscribe(() => {
      this.submitting = false;
      this.completed = true;
      this.hide();
    });
  }

  public show() {
    this.modal.show();
  }

  public hide() {
    this.modal.hide();
    if (this.completed) {
      this.success.emit(null);
    }
  }

  public mediaSelected(files: File[]) {
    const file: File = files[0];
    if (this.supportedFileTypes.includes(file.type)) {
      this.chappsImageCropperComponent.computeImages([file]);
    }
  }

  private convertFileToUrl(file: File, index: number) {
    this.multimediaFiles[index] = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.multimedia[index] = {url: reader.result as string, type: MultimediumType.PICTURE} as Multimedium;
    };
  }

  public onPhotoDelete(index: number) {
    this.multimedia.splice(index, 1);
    this.multimediaFiles.splice(index, 1);
  }

  onImageSubmitted(image: File) {
    this.addNewMedia(image);
  }

  private addNewMedia(file: File) {
    if (file) {
      this.convertFileToUrl(file, this.multimedia.length);
    }
  }

  fileChangeEvent(isFile: boolean): void {

    const files: { [key: string]: File } = isFile ? this.file.nativeElement.files : this.image.nativeElement.files;
    const pendingFiles: File[] = [];

    for (const key in files) {
      if (!isNaN(parseInt(key, null))) {
        pendingFiles.push(files[key]);
      }
    }
    this.chappsImageCropperComponent.computeImages(pendingFiles);
  }

  public openCamera(){
    this.image.nativeElement.click();
  }

  public addFiles() {
    this.file.nativeElement.click();
  }

  public fileCropped(file: UploadingImage) {
    // this.files.add(file);
    if (file) {
      this.convertFileToUrl(file.file, this.multimedia.length);
    }
  }
}
